<script>
export default {
    props: {
        name: 'inner-table',
        options: {
            type: Object,
            required: true
        },
        first_inner_options: {
            type: Object,
            required: false
        },
        second_inner_options: {
            type: Object,
            required: false
        }

    },

    /* mounted() {
        this.options.rows.forEach(item => {
            const contains = this.first_inner_options.rows.some( element => element.relation_id == item.self_id);
            this.options.has_inner = contains;
        });
    }, */

    data() {
        return {
            activeRow: ""
        }
    },

    methods: {
        toggleActiveRow(_true, id) {
            if (_true) {
                if (id != this.activeRow) {
                    this.activeRow = id;
                    this.first_inner_options.active_row = id;
                } else {
                    this.activeRow = "";
                }
            }
        },

        hasInner(item) {
            if (this.first_inner_options) {
                return this.first_inner_options.rows.some(element => element.relation_id == item.self_id);
            }
        },

        emitValue(row, cell) {
            const value = [row, cell]
            this.$emit('clickInnerCell', value);
        },
        handleInnerCellButtonClick(event) {
            const value = event;
            this.$emit('innerButtonClick', value)
        },
    }
}
</script>

<template>
    <div class="inner-table-container">
        <div class="inner-table" :style="{ width: options.scale, fontSize: options.font_size ? options.font_size : null }"
            :id="`table_${options.table_relation_id}`">
            <div class="inner-header-row" :style="{ backgroundColor: options.header_bg, color: options.header_font }">
                <div class="inner-header-col" style="flex: .03; justify-content: center;"
                    :style="{ borderRight: options.header_border_color ? `thin solid ${options.header_border_color}` : 0 }"
                    v-if="options.is_enumerated">
                    No
                </div>
                <div v-for="(header, index) in options.headers" :key="index" class="inner-header-col"
                    :style="{ justifyContent: header.align, maxWidth: `${options.col_widths[_index] * 100}%`, flex: options.col_widths[index], borderRight: options.header_border_color ? `thin solid ${options.header_border_color}` : 0 }">
                    {{ header.value }}
                </div>
            </div>
            <div class="inner-row-container" v-for="(row, index) in options.rows" :key="index">
                <div class="inner-rows"
                    :style="{ backgroundColor: options.rows_bg, color: options.rows_font, zIndex: options.table_level, borderTop: options.rows_top_border_color ? `.15em solid ${options.rows_top_border_color}` : 0, borderBottom: index == (options.rows.length - 1) ? 0 : null }"
                    :class="{ 'has-inner-joint': hasInner(row), 'opened': activeRow == row.self_id }"
                    :id="`row_${row.relation_id}`" @click="toggleActiveRow(hasInner(row), row.self_id)"
                    v-if="options.active_row == row.relation_id">
                    <div class="inner-cells" style="flex: .03; justify-content: center;"
                        :style="{ borderRight: options.header_border_color ? `thin solid ${options.cells_border_color}` : 0 }"
                        v-if="options.is_enumerated">
                        {{ index + 1 }}
                    </div>
                    <div v-for="(cell, _index) in row.cells" :key="_index" class="inner-cells"
                        :style="{ justifyContent: cell.is_button && cell.ref != 'plan' ? 'center' : null, textAlign: cell.align, maxWidth: `${options.col_widths[_index] * 100}%`, flex: options.col_widths[_index], borderRight: options.rows_border_color ? `thin solid ${options.rows_border_color}` : 0 }">
                        <span v-if="!cell.is_button">
                            {{ cell.value }}
                        </span>
                        <span v-else v-html="cell.value" @click.stop="emitValue(row, cell)"></span>
                    </div>
                </div>
                <div v-if="first_inner_options && row.self_id == activeRow" :style="{ zIndex: options.table_level - 1 }">
                    <inner-table :options="first_inner_options ? first_inner_options : null"
                        :first_inner_options="second_inner_options ? second_inner_options : null"
                        @clickInnerCell="handleInnerCellButtonClick($event)"
                        @innerButtonClick="handleInnerCellButtonClick($event)"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<style lang="scss" scoped>
.inner-table-container {
    display: flex;
    justify-content: center;
}

.inner-table {
    margin: 0;

    >.inner-header-row {
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        height: 3.5em;

        >.inner-header-col {
            padding: .5em;
            border-right: thin solid white;
        }
    }

    >.inner-row-container {
        >.inner-rows {
            display: flex;
            flex-wrap: wrap;
            position: relative;
            height: fit-content; // 4em to fit-content

            >.inner-cells {
                overflow: auto;
                padding: .5em;
                border-right: thin solid lightgray;
                flex: 1;
            }

            ::-webkit-scrollbar {
                width: .3em;
                height: .3em;
            }
        }
    }
}

.inner-table {
    >.inner-row-container {
        &:last-of-type {
            >.inner-rows {
                border-bottom-left-radius: .75em;
                border-bottom-right-radius: .75em;

                box-shadow: 0 .35em .33em .1em gray;
            }
        }
    }
}

.opened {
    box-shadow: 0 0em .33em .1em gray;
    border-bottom: .15em solid var(--rows-border-top-color);
}

.inner-header-col,
.inner-cells {
    display: flex;
    align-items: center;
}

.inner-header-col {
    font-weight: bold;
}

.has-inner-joint {
    cursor: pointer;

    &:hover {
        filter: brightness(92.5%);
    }
}
</style>